<script setup lang="ts">
import { runtimeConfig } from "../api/config";
import SiteLogo from "./SiteLogo.vue";

defineProps<{ currentPath: string }>();

const links = [
  { href: "/", label: "功能" },
  { href: "/legal/", label: "隐私与协议" },
];

function isCurrentLink(currentPath: string, href: string): boolean {
  const normalizedHref = href !== "/" ? href.replace(/\/$/, "") : href;
  if (normalizedHref === "/legal") return ["/legal", "/privacy", "/terms", "/refund-policy"].includes(currentPath);
  return currentPath === normalizedHref;
}
</script>

<template>
  <header class="site-header">
    <div class="site-header__inner page-width">
      <a class="site-logo-link" href="/" data-route aria-label="图萃首页">
        <SiteLogo />
      </a>
      <nav aria-label="主要导航">
        <a
          v-for="link in links"
          :key="link.href"
          :href="link.href"
          data-route
          :aria-current="isCurrentLink(currentPath, link.href) ? 'page' : undefined"
        >{{ link.label }}</a>
      </nav>
      <a v-if="runtimeConfig.extensionInstallUrl" class="header-action" :href="runtimeConfig.extensionInstallUrl">安装扩展</a>
    </div>
  </header>
</template>
